import type { SeverityLevel } from '@sentry/vue';

const BREADCRUMB_CATEGORIES = {
  MAIN: 'main-page',
  SEARCH: 'search-page', // events that occur on the search page
  BOOKING: 'booking-page',
};

// https://docs.sentry.io/platforms/javascript/guides/vue/usage/set-level/
const LEVEL = {
  FATAL: 'fatal', // App flow breaks and a user can't use it
  ERROR: 'error', // Default severity level
  LOG: 'log',
  INFO: 'info',
  DEBUG: 'debug',
} as Record<string, SeverityLevel>;

const ERROR_PREFIXES = {
  AVIA: 'AVIA_ERR_FAILED',
  RW: 'RW_ERR_FAILED',
  DEFAULT: 'ERR_FAILED',
};

export const sentryConfig = {
  BREADCRUMB_CATEGORIES,
  LEVEL,
  ERROR_PREFIXES,
};
